/*###########################################################################
// Video player
//#########################################################################*/

const videoPlayer = {
	config: {
			videoPlayer: '.videoPlayer',
			video: '.responsive-video',
			videoPlayerButton: '.videoPlayer__playButton',
			videoPlayerControls: '.videoPlayer__controls',
			videoPlayerControlsPlayButton: '.videoPlayer__controls__playButton',
			responsiveVideo: '.responsive-video',
			videoDuration: '.videoPlayer__controls__duration',
			iconPlay: '.videoPlayer__controls__icon-play',
			iconPause: '.videoPlayer__controls__icon-pause'

	},

	elements: {
	},

	init() {
			const self = this
			self.elements.videoPlayers = document.querySelectorAll(self.config.videoPlayer)

			if (self.elements.videoPlayers !== null) {
					for (let i = 0; i < self.elements.videoPlayers.length; i++) {

						const videoPlayer = self.elements.videoPlayers[i]

						self.handleVideoPlayer(videoPlayer)
					}
			}
	},

	handleVideoPlayer(videoPlayer) {

		const self = this
		const video = videoPlayer.querySelector(self.config.video)
		const videoPlayerButton = videoPlayer.querySelector(self.config.videoPlayerButton)
		const videoPlayerControls = videoPlayer.querySelector(self.config.videoPlayerControls)
		const videoPlayerControlsPlayButton = videoPlayer.querySelector(self.config.videoPlayerControlsPlayButton)
		const videoDuration = videoPlayer.querySelector(self.config.videoDuration)
		const iconPlay = videoPlayer.querySelector(self.config.iconPlay)
		const iconPause = videoPlayer.querySelector(self.config.iconPause)

    videoPlayerButton.addEventListener('click', function(){
			if (video.paused) {
					video.play();
			} else {
					video.pause();
			}
		})

		videoPlayerControlsPlayButton.addEventListener('click', function(){
				if (video.paused) {
						video.play();
				} else {
						video.pause();
				}
		})

		video.addEventListener('playing', function() {
			videoPlayerButton.classList.add('hidden')
			videoPlayerControls.classList.remove('videoPlayer__controls--hidden')
			videoPlayerControlsPlayButton.classList.add('playing')
			iconPlay.classList.add('hidden')
			iconPause.classList.remove('hidden')

			videoPlayer.addEventListener('mouseover', function(){
				videoPlayerControls.classList.remove('videoPlayer__controls--hidden')
			})

			videoPlayer.addEventListener('mouseout', function(){
				videoPlayerControls.classList.add('videoPlayer__controls--hidden')
			})

		})

		video.addEventListener('pause', function() {
			iconPlay.classList.remove('hidden')
			iconPause.classList.add('hidden')
		})

		video.addEventListener('timeupdate', function(e){
			let s = parseInt(video.currentTime % 60)
      let m = parseInt((video.currentTime / 60) % 60)
			m = m < 10 ? '0' + m : m
			s = s < 10 ? '0' + s : s
			videoDuration.textContent = m + ':' + s
		})
	}
}

window.addEventListener('load', function () {
	videoPlayer.init()
})
